import React from "react";
import {
  FieldArray,
  FieldControl,
  FieldGroup,
  FormBuilder,
} from "react-reactive-form";
import { CFormInput, CFormSelect, CButton } from "@coreui/react";

const LaySummaryTgNames = ({ formGroup }) => {
  const addNewTgName = () => {
    const control = formGroup.controls.qTgNames;
    control.push(
      FormBuilder.group({
        name: [""],
        role: [""],
      })
    );
  };

  const removeTgName = index => {
    const control = formGroup.controls.qTgNames;
    control.removeAt(index);
  };

  const renderFieldGroup = () => (
    <>
      <div className="tg-name-input">
        <FieldControl
          name="name"
          render={({ handler }) => (
            <CFormInput
              className="input-text"
              type="text"
              placeholder="Treatment/Group name"
              {...handler()}
            />
          )}
        />
      </div>
      <div className="tg-role-select">
        <FieldControl
          name="role"
          render={({ handler }) => (
            <CFormSelect className="input-select" {...handler()}>
              {roleOptions.map((option, i) => (
                <option key={i} value={option.value}>
                  {option.title}
                </option>
              ))}
            </CFormSelect>
          )}
        />
      </div>
    </>
  );

  const roleOptions = [
    { value: "", title: "- Choose role -" },
    { value: "Treatment Group", title: "Treatment Group" },
    { value: "Active Comparator", title: "Active Comparator" },
    { value: "Dose Group", title: "Dose Group" },
    { value: "Placebo", title: "Placebo" },
  ];

  return (
    <div data-field-name="qTgNames">
      <FieldArray
        name="qTgNames"
        render={({ controls }) => (
          <>
            {controls.map((itemControl, iControl) => (
              <div
                key={`tg-name-${iControl}-${itemControl.value.role}`}
                className="tg-name-item">
                <div className="tg-name-row">
                  <FieldGroup control={itemControl} render={renderFieldGroup} />
                  {controls.length > 1 && (
                    <CButton
                      color="danger"
                      variant="outline"
                      size="sm"
                      onClick={() => removeTgName(iControl)}
                      className="remove-btn">
                      Remove
                    </CButton>
                  )}
                </div>
              </div>
            ))}
            <div className="add-another-container">
              <CButton
                color="primary"
                variant="outline"
                size="sm"
                onClick={addNewTgName}
                className="add-another-btn">
                Add another
              </CButton>
            </div>
          </>
        )}
      />
    </div>
  );
};

export default LaySummaryTgNames;
